import { isApiError } from '../../api/client'
import type { QueueItem } from '@rp/contracts'
import { Button } from '../../design'
import { RECLASSIFY_COPY } from './copy'
import { useReclassify } from './useReclassify'

export const NotSpamButton = ({ item, label }: { item: QueueItem; label: string }) => {
  const mutation = useReclassify(item.id)
  return (
    <>
      <Button pending={mutation.isPending} pendingLabel={RECLASSIFY_COPY.moving} onClick={() => mutation.mutate({ folder: 'inbox' })}>
        {label}
      </Button>
      {isApiError(mutation.error) ? (
        <span className="tone-danger" role="alert">
          {mutation.error.message}
        </span>
      ) : null}
    </>
  )
}
